import * as React from "react";

export const FlagUnitedStates = () => <span>🇺🇸</span>;
